const state = {
  dialog: true
}
const mutations = {
  DISMISS_WELCOME_MODAL: state => {
    state.dialog = false
  }
}
const actions = {
  dismissWelcomeModal: ({ commit }) => {
    commit("DISMISS_WELCOME_MODAL");
  }
}
const getters = {}

export default {
  state,
  mutations,
  actions,
  getters
}